import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HeightWidthTuple } from 'src/app/model/util-classes/height-width-tuple';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { EMPTY_OBJECT } from 'src/globals/globals';
import { WindowStickerSizeSelectionList } from './window-sticker-size-selection-list';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class WindowStickerSizeSelectionListControllerRequestService {
  private static BASE_URL = '/window_sticker_sizes/selectionlist';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private deserialize = (res: any): WindowStickerSizeSelectionList | {} => {
    if (res == null) {
      return EMPTY_OBJECT;
    }

    const lyingDown =
      res.lyingDown == null
        ? []
        : res.lyingDown.map((t) => this.deserializeTuple(t));
    const square =
      res.square == null ? [] : res.square.map((t) => this.deserializeTuple(t));
    const upright =
      res.upright == null
        ? []
        : res.upright.map((t) => this.deserializeTuple(t));
    return {
      lyingDown: lyingDown,
      square: square,
      upright: upright,
    };
  };
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      WindowStickerSizeSelectionListControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getSelectionList(): Promise<WindowStickerSizeSelectionList | {}> {
    return this.get('', this.deserialize).toPromise();
  }

  private deserializeTuple(t: any): HeightWidthTuple {
    const toReturn = new HeightWidthTuple(t.height, t.width);
    toReturn.calculateDisplay();
    return toReturn;
  }
}
